import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import {
	useGetAllCustomersQuery,
	useGetChildCustomerQuery,
} from "../../../Redux/service/Customer/Customer";

export default function CustomersMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	const { isLinking } = useContext(popupcontext);
	// const [mergedData, setMergedData] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedCustomers, setSelectedCustomers] = useState([]);
	const [groups, setGroups] = useState([]);

	// let { data: NotificationsVehicles, refetch: NotificationsVehiclesRefetch } =
	// 	useGetAllTechnicianFromUsersQuery();
	console.log("userId", userId);
	let { data: UserCustomers, refetch: UserCustomersRefetch } =
		useGetAllCustomersQuery({ page: 1, limit: 10000 });
	let { data: Users, refetch: UsersRefetch } = useGetChildCustomerQuery(
		userId,
		{ skip: !userId }
	);
	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};
	const isFirstMount = useRef(true);
	// useEffect(() => {
	// 	if (AdminFieldStaff && UsersNotifications) {
	// 		const merged = [
	// 			...AdminFieldStaff?.technicians,
	// 			...UsersNotifications?.fieldWorkers,
	// 		];
	// 		const unique = merged.filter(
	// 			(item, index, self) =>
	// 				index === self.findIndex((t) => t.technician_id === item.id)
	// 		);
	// 		setMergedData(unique);
	// 	}
	// }, [AdminFieldStaff, UsersNotifications]);
	useEffect(() => {
		if (isFirstMount.current || UserCustomersRefetch) {
			setGroups(
				UserCustomers?.data?.map((i) => ({
					value: i.tc_user_id,
					label: i.name,
				}))
			);
		}
		isFirstMount.current = false;
	}, [UserCustomers, UserCustomersRefetch]);

	useEffect(() => {
		if (type === "users") {
			if (Users) {
				setSelectedCustomers(Users?.data?.customers?.map((i) => i.id));
			}
		}
	}, [Users, type]);

	useEffect(() => {
		if (isLinking) {
			if (type === "users") {
				UsersRefetch();
			}
		}
	}, [isLinking, vehicleId, type, UsersRefetch]);
	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedCustomers((prev) => [...prev, value]);
						handleLink(value, "managedUser", "Customer");
					}}
					onDeselect={(value) => {
						setSelectedCustomers((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "managedUser", "Customer");
					}}
					value={selectedCustomers || ""}
					options={groups}
					open={isOpen}
					allowClear
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
